<template>
    <div id="app">
        <main>
            <router-view></router-view>
        </main>
    </div>
</template>

<script>
    export default {
        name: 'app'
    };
</script>

<style lang="scss">
    body {
        font-family: 'Open Sans', sans-serif;
        font-size: calc(1rem + 1vw);
        color: white;
    }

    html,
    body,
    main {
        &, > * {
            height: 100%;
            margin: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// App.vue?a74671fc